module.exports = __webpack_public_path__ + "img/mind_skeleton_4.e0898f13.png";